module.exports = __webpack_public_path__ + "static/media/Schedule.5ec0c928.svg";